import style from './style.css';

const LendersSection = () => {
  const lenderImages = [
    'https://iccdn.in/lenders/IDFCFirst-colorBG.png',
    'https://iccdn.in/lenders/HDFCBank-colorBG.png',
    'https://iccdn.in/lenders/Kotak-colorBG.png',
    'https://iccdn.in/lenders/ICICIBank-colorBG.png',
    'https://iccdn.in/lenders/HomeCredit-colorBG.png',
    'https://iccdn.in/lenders/Federal-colorBG.png',
    'https://iccdn.in/lenders/BankOfBaroda-colorBG.png',
  ];
  return (
    <div className={style.lenderListContainer}>
      <div className={`text100 bold-text text-center ${style.lenderHeading}`}>
        Our Lending Partners
      </div>
      <div className={style.lenderMerchantListDiv}>
        {lenderImages.map((lenderImage) => {
          return (
            <img src={lenderImage} alt='logo' className={style.lenderImage} />
          );
        })}
      </div>
    </div>
  );
};

export default LendersSection;



// WEBPACK FOOTER //
// ./routes/campaign-activation/componentsVC/lenders/index.js